module.exports = __webpack_public_path__ + "img/oil-truck.29515ec7.svg";